// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n/* 统一组件中的特殊组件 */\n[data-v-0dbd65a0] .el-dialog__header {\n  display: none !important;\n}\n.selfDialogClose[data-v-0dbd65a0] {\n  display: inline-block;\n  position: absolute;\n  right: 0;\n  top: 3px;\n  pointer-events: auto;\n  z-index: 999;\n  font-size: 16px;\n  color: #363f4d;\n}", ""]);
// Exports
module.exports = exports;
